import styled from 'styled-components'

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  @media (max-width: 762px) {
    flex-direction: column;
    gap: 10px;
  }
`
